import 'react';
import 'prop-types';
import { css } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'airbnb-prop-types';
import '../parseIcons.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import { a as Icon$1 } from '../chunk-16546651.js';
import '../Spinner/styled.js';
import Spinner from '../Spinner/index.js';
import Input$1 from 'reakit/Input';

var LoadingSpinner = styled(Spinner).withConfig({
  displayName: "styled__LoadingSpinner",
  componentId: "kl4ffb-0"
})(["position:absolute;top:10px;right:10px;z-index:2;"]);
var sizeProperties = {
  small: css(["& + ", "{top:8px;}&{", ";}"], LoadingSpinner, theme('fannypack.Input.sizes.small')),
  default: css(["&{", ";}"], theme('fannypack.Input.sizes.default')),
  medium: css(["& + ", "{top:10px;right:10px;}&{", ";}"], LoadingSpinner, theme('fannypack.Input.sizes.medium')),
  large: css(["& + ", "{top:10px;right:10px;}&{", ";}"], LoadingSpinner, theme('fannypack.Input.sizes.large'))
};
var wrapperSizeProperties = {
  small: css(["font-size:0.8rem;&{", ";}"], theme('fannypack.Input.Wrapper.sizes.small')),
  default: css(["&{", ";}"], theme('fannypack.Input.Wrapper.sizes.default')),
  medium: css(["font-size:1.25rem;&{", ";}"], theme('fannypack.Input.Wrapper.sizes.medium')),
  large: css(["font-size:1.5rem;&{", ";}"], theme('fannypack.Input.Wrapper.sizes.large'))
};
var stateProperties = css(["border-color:", ";box-shadow:", " 0px 0px 0px 1px !important;"], function (props) {
  return palette("" + props.state)(props);
}, function (props) {
  return palette("" + props.state)(props);
}); // @ts-ignore

var Icon = styled(Icon$1).withConfig({
  displayName: "styled__Icon",
  componentId: "kl4ffb-1"
})(["fill:", ";height:2.5em;margin:0 0.75em;top:0;", ";"], palette('text100'), theme('fannypack.Input.Icon.base'));
var InputWrapper = styled(Box).withConfig({
  displayName: "styled__InputWrapper",
  componentId: "kl4ffb-2"
})(["align-items:center;position:relative;width:100%;&{", ";}&{", ";}"], theme('fannypack.Input.Wrapper.base'), function (props) {
  return props.styledSize && wrapperSizeProperties[props.styledSize];
});
var Input = styled(Input$1).withConfig({
  displayName: "styled__Input",
  componentId: "kl4ffb-3"
})(["-webkit-appearance:none;border:1px solid #bdbdbd;box-shadow:inset 0px 1px 2px #e5e5e5;border-radius:0.2em;height:2.5em;width:100%;padding:0.4em 0.6em;&[disabled]{background-color:", ";box-shadow:unset;&{", ";}}&:focus{outline:unset;z-index:2;border-color:", ";box-shadow:", " 0px 0px 0px 1px !important;&{", ";}}&::placeholder{opacity:0.6;&{", ";}}&{", ";}&{", ";}&{", ";}&{", ";}&{", ";}"], palette('white700'), theme('fannypack.Input.disabled'), function (props) {
  return palette('primary')(props);
}, function (props) {
  return palette('primary')(props);
}, theme('fannypack.Input.focus'), theme('fannypack.Input.placeholder'), function (props) {
  return props.after && css(["padding-right:2.3em;"]);
}, function (props) {
  return props.before && css(["padding-left:2.3em;"]);
}, theme('fannypack.Input.base'), function (props) {
  return props.styledSize && sizeProperties[props.styledSize];
}, function (props) {
  return props.state && stateProperties;
});

export default Input;
export { Icon, Input, InputWrapper, LoadingSpinner, sizeProperties, stateProperties, wrapperSizeProperties };
